// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"533":"201cfb76","3727":"5fcec072","5309":"d05a8eee","6178":"192951de","6421":"5fcec072","8228":"5fcec072","9350":"948ed223"}[chunkId] + ".chunk.css";
};